export default {
  set(state, { data }) {
    state.customers = data;
  },
  show(state, { data }) {
    state.customer = data;
  }
}